import { ServiceFetch } from '../service-fetch'

export default class InvoiceCustomerCostModel extends ServiceFetch {
    getInvoiceCustomerCostBy = (data) => this.authFetch({
        url: 'invoice-customer-cost/getInvoiceCustomerCostBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}